module.exports = __webpack_public_path__ + "static/media/c3e57646.jpg";